import { useState, useEffect } from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { displayDate } from '../../utils/date';
import { parseMoney, formatMoney } from '../../utils/money';
import { getItem, getItemFolioRanges } from '../../services/Items/Inventory';

function ItemDetailsModal({
    show,
    handleClose,
    id,
    handleOpenModalLogs,
    onOpenProcess,
    onOpenOutput,
    onOpenEdit,
    onOpenEvidence,
    readOnly = false,
    refreshToken = 0
}) {
    const [data, setData] = useState({});
    const [folioRanges, setFolioRanges] = useState([]);

    const isRaw = data?.stage === 'raw';
    const isProcessing = data?.stage === 'processing';
    const isFinished = !!readOnly;

    const hasStock = Number(data?.quantity ?? 0) > 0;
    const canDoFinalActions = data?.stage === 'finished' && hasStock && !readOnly;
    const canManageEvidence = data?.stage === 'finished';

    const fmt = (n) => (Number.isFinite(Number(n)) ? Number(n).toLocaleString('es-MX') : n ?? '');

    useEffect(() => {
        if (!show || !id) return;
        setData({});
        setFolioRanges([]);
        getItem(id).then(setData);
        getItemFolioRanges(id).then(setFolioRanges);
    }, [id, show, refreshToken]);

    const isValidValue = (value) => {
        return value !== null && value !== undefined && value !== '';
    };

    const formatFolio = (r) => {
        const unitLabel = r.units === 'CAJA_12' ? 'Caja (12)' : 'Botella 750';
        const count = Number(r.count ?? 0);
        const isSingle = count <= 1 || r.startFolioName === r.endFolioName;

        return `${unitLabel}: ${isSingle ? r.startFolioName : `${r.startFolioName} – ${r.endFolioName} (${r.count})`}`;
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Detalles</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xl={12} >
                        <Table bordered hover responsive>
                            <thead>
                                <tr className='table-dark'>
                                    <th className='text-center'>
                                        Campo
                                    </th>
                                    <th className='text-center'>
                                        Valor
                                    </th>
                                </tr>
                            </thead>
                            {
                                data ? (
                                    <tbody>
                                        {isValidValue(data.name) && (
                                            <tr >
                                                <td className='bg-light  text-end' >
                                                    Nombre:
                                                </td>
                                                <td className='text-center'>
                                                    {data.name}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.description) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Descripción:
                                                </td>
                                                <td className='text-center'>
                                                    {data.description}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.additionalNotes) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Notas adicionales:
                                                </td>
                                                <td className='text-center'>
                                                    {data.additionalNotes}
                                                </td>
                                            </tr>
                                        )}
                                        {(isValidValue(data.acquisitionDateHumanFormatted) || isValidValue(data.acquisitionDate)) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Fecha de adquisición:
                                                </td>
                                                <td className='text-center'>
                                                    {data.acquisitionDateHumanFormatted || displayDate(data.acquisitionDate)}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.quantity) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Cantidad en inventario:
                                                </td>
                                                <td className='text-center'>
                                                    {fmt(data.quantity)} {data.unitOfWeightMeasurement}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.unitPrice) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Costo unitario:
                                                </td>
                                                <td className='text-center'>
                                                    $ {data.unitPrice}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.final_price) && (
                                            <tr>
                                                <td className='bg-light text-end'>Precio final:</td>
                                                <td className='text-center'>{formatMoney(parseMoney(data.final_price))}</td>
                                            </tr>
                                        )}
                                        {isValidValue(data.categoryName) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Categoría:
                                                </td>
                                                <td className='text-center'>
                                                    {data.categoryName}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.locationName) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Ubicación:
                                                </td>
                                                <td className='text-center'>
                                                    {data.locationName}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.statusName) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Estatus:
                                                </td>
                                                <td className='text-center'>
                                                    {data.statusName}
                                                </td>
                                            </tr>
                                        )}
                                        {isValidValue(data.assignedToUser) && (
                                            <tr >
                                                <td className='bg-light text-end'>
                                                    Asignado a:
                                                </td>
                                                <td className='text-center'>
                                                    {data.assignedToUser}
                                                </td>
                                            </tr>
                                        )}
                                        {(folioRanges?.length > 0) && (
                                            <tr>
                                                <td className='bg-light text-end'>Folios asignados:</td>
                                                <td className='text-center'>
                                                    <ul className='mb-0 text-center'>
                                                        {folioRanges.map((r, i) => (
                                                            <li key={i}>{formatFolio(r)}</li>
                                                        ))}
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                ) :
                                    (
                                        <tbody>
                                            <tr >
                                                <td className='text-center'>
                                                </td>
                                                <td className='text-center'>
                                                </td>
                                            </tr>
                                        </tbody>
                                    )
                            }
                        </Table>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button
                    variant={isRaw ? 'primary' : 'warning'}
                    onClick={() => onOpenProcess?.({ itemId: id, currentStage: data.stage })}
                    disabled={isFinished || (!isRaw && !isProcessing)}
                >
                    {isRaw ? 'Iniciar destilación' : isProcessing ? 'Envasar producto terminado' : 'Sin acciones'}
                </Button>

                <div className="d-flex align-items-center gap-2">
                    {canDoFinalActions && (
                        <div className="d-flex gap-2 me-3">
                            <Button size="sm" variant="danger" onClick={() => onOpenOutput?.(id)}>
                                Registrar salida
                            </Button>
                        </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                        {canManageEvidence && (
                            <Button size="sm" variant="outline-secondary" onClick={() => onOpenEvidence?.(id, data.name)}>
                                Evidencia
                            </Button>
                        )}

                        <Button size="sm" variant="outline-info" onClick={() => handleOpenModalLogs(id)}>
                            Historial de cambios
                        </Button>

                        <Button size="sm" variant="outline-warning" onClick={() => onOpenEdit?.(id)}>
                            Editar
                        </Button>

                        <Button size="sm" variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ItemDetailsModal;